function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-8207 -2329 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M-8198-2329a9 9 0 109 9 8.963 8.963 0 00-9-9zm0 16a7 7 0 117-7 6.957 6.957 0 01-7 7zm.8-3.7v.4a.472.472 0 01-.5.5h-.5a.472.472 0 01-.5-.5v-.4a.472.472 0 01.5-.5h.5a.472.472 0 01.5.5zm0-6.9l-.1 5.1a.472.472 0 01-.5.5h-.4a.56.56 0 01-.5-.6l-.1-5c0-.3.2-.4.5-.4h.6c.3 0 .5 0 .5.4z"
})));